import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Shared queryKey — import this constant instead of hardcoding the array. */
export const interviewAvailabilityQueryKey = ['cabin', 'interview-sim', 'availability'];

/**
 * useInterviewAvailability — GET /api/cabin/interview-sim/availability
 *
 * Response shape:
 *   { can_start: bool, cooldown_days: int, last_session_at: iso|null,
 *     next_available_at: iso|null, remaining_seconds: int|null }
 *
 * Admin/instructor always receives can_start: true (other fields null).
 * Students in cooldown receive can_start: false with timing fields.
 */
async function fetchAvailability() {
  const token = getToken();
  const res = await axios.get(`${API}/cabin/interview-sim/availability`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
}

export function useInterviewAvailability() {
  return useQuery({
    queryKey: interviewAvailabilityQueryKey,
    queryFn: fetchAvailability,
    // Refresh every 60s so the countdown stays accurate after tab switch
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: typeof window !== 'undefined' && !!getToken(),
    // On error (network, 5xx), fail open — let the start endpoint enforce cooldown
    retry: 1,
  });
}
